snt-nav {
    align-items: center;
    &[expander=all],
    &[expander=keyboard] {
        snt-nav-item {
            margin-right: 40px;
            &.dropdown {
                .show {
                    .expander {
                        &:after {
                            content: "\23F6";
                        }
                    }
                }
            }
        }
        .expander {
            background: transparent;
            border: 0;
            margin: 0;
            padding: 0;
            appearance: none;
            position: absolute;
            top: 5px;
            transform: translateY(-50%);
            display: flex;
            font-size: 12px;
            @media(min-width: map-get($grid-breakpoints, lg)) {
                left: calc(100% + 0.5rem);
            }
            &:focus {
                outline: 2px solid $color-grey-07;
            }
        }
    }
    &[expander=all] {
        .expander {
            opacity: 1;
        }
        .snt-link-hover-effect .expander {
            color: #147582;
        }
        .snt-link-hover-effect .menu-nav-icon {
            border-color: #147582;
        }
    }
    &[expander=keyboard] {
        snt-nav-item {
            &:focus-within {
                &:not(:active) {
                    .expander {
                        opacity: 1;
                    }
                    .snt-link-hover-effect .expander {
                        color: #147582;
                    }
                    .snt-link-hover-effect .menu-nav-icon {
                        border-color: #147582;
                    }
                }
            }
        }
        snt-nav-item {
            .menu-nav-icon {
                display: flex;
                align-items: center;
                height: 26px;
                border-bottom: 3px solid transparent;
            }
            .expander {
                @media(min-width: map-get($grid-breakpoints, lg)) {
                    opacity: 0;
                }
            }
        }
    }
    &[separator] {
        &>snt-nav-item {
            &:last-child {
                border-right: none;
            }
        }
    }
    &#main-nav {
        & > snt-nav-item {
            margin: 0 20px;
        }
        
    }
    &.main-nav {
        snt-nav-item {
            margin: 0 0 0.5rem 0;
            @media(min-width: map-get($grid-breakpoints, lg)) {
                margin: 1.075rem 2.175rem 0 0;
            }
            a {
                font-family: Averta-ExtraBold;
                font-size: 1em;
            }
            /* Subnav */
            snt-nav-item {
                margin: 0 0 0.125rem 0;
                @media(min-width: map-get($grid-breakpoints, lg)) {
                    padding: 0;
                    margin: 0;
                }
                a {
                    font-family: Averta-Regular;
                }
            }
        }
    }
    &.secondary-nav {
        a,
        button {
            font-size: 0.875rem;
            line-height: 1.25rem;
        }
        margin-bottom: 0.5rem;
        margin-top: 2px;
    }
    &.actions-nav {
        snt-nav-item {
            @media (min-width: map-get($grid-breakpoints, md)) {
                margin: 0 0 0 1.5rem;
            }
            a {
                font-family: Averta-ExtraBold;
            }
        }
    }
    &.theme-header-nav {
        snt-nav-item {
            display: block;
            line-height: 1.3125rem;
            .nav-item,
            .nav-link {
                padding: 0;
                margin: 0;
            }
        }
        snt-link {
            a {
                display: inline-block;
                margin: 0;
                position: relative;
                text-decoration: none;
                border-bottom: none;
            }
        }
        snt-button {
            &:hover {
                snt-icon,
                button {
                    // color: $color-primary;
                    color: #147582;
                }
            }
            snt-icon {
                margin-right: 8px;
            }
        }
        snt-link,
        snt-button:not(.cta) {
            a,
            button {
                color: #323232;
                margin: 2px;
                outline: 2px solid transparent;
                padding: 0;
                white-space: nowrap;
                &:active,
                &:focus,
                &:hover {
                    // color: $color-primary;
                    font-family: Averta-ExtraBold;
                    &:before {
                        visibility: hidden;
                    }
                }
                &:focus {
                    outline: 2px solid $color-grey-07;
                    padding: 0;
                }
                &:before {
                    background-color: $color-primary;
                    height: 2px;
                }
                /* Take up bold face space up front to prevent anchor element expanding on hover and affecting sibling elements */
                &:after {
                    display: block;
                    font-family: Averta-ExtraBold;
                    content: attr(hidden-title);
                    height: 0;
                    overflow: hidden;
                    visibility: hidden;
                    font-size: 1.015em;
                }
            }
            &[current] {
                a,
                button {
                    &:before {
                        width: 100%;
                        visibility: visible;
                        transform: scaleX(1);
                    }
                }
            }
        } // END snt-link, snt-button
    } // END .theme-header-nav
}